// extracted by mini-css-extract-plugin
export var button = "_lp-0";